// Copyright 2023, Avation Medical. All rights reserved.
// 
// This code is proprietary and confidential information of Avation Medical. Any use, reproduction, modification
// or distribution of the code without the express prior written consent of Avation Medical is strictly prohibited.

import { FormGroup } from "@angular/forms";
import { APIError } from "../models/api-error.interface";

export function handleBadRequest(formGroup: FormGroup, response: any) {
    if(response.status === 400 && response.error) {
      let apiError: APIError = response.error;
      Object.keys(apiError).forEach(key => {
        let control = formGroup.get(key);
        if(control) {
          control.setErrors({ apiErrors: apiError[key] });
          control.markAsTouched();
        }
      });
    }
}